module.exports = __webpack_public_path__ + "static/half_orc_mark_of_finding-9ee75a433446e794a03b8340d23046ec.png";